import { makeStyles, shorthands, tokens, typographyStyles, } from '@fluentui/react-components';

export const useTrackingStatusPopoverStyles = makeStyles({
  root: {
    color: tokens.colorStatusSuccessForeground1,
    backgroundColor: tokens.colorStatusSuccessBackground1,
    ...shorthands.borderColor(tokens.colorStatusSuccessBorder1),
  },
  warningState: {
    color: tokens.colorStatusWarningForeground2,
    backgroundColor: tokens.colorStatusWarningBackground1,
    ...shorthands.borderColor(tokens.colorStatusWarningBorder1),
  },
  popover: {
    maxWidth: 'fit-content',
    paddingRight: '30px',
    '& .tracking-status-col': {
      paddingRight: '10px',
    },
  },
  popoverLearnMore: {
    color: tokens.colorNeutralForeground3,
  },
  popoverContent: {
    maxWidth: '350px',
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('10px'),
    alignItems: 'flex-start',
  },
  title: {
    ...typographyStyles.title3,
  },
});
